// material-ui
import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

// project imports
import NavGroup from '../components/NavGroup'
import menuItem from 'menu-items'

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
  const { t } = useTranslation('layout')
  const navItems = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={item.id} item={item} />
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            {t('menuItemsError')}
          </Typography>
        )
    }
  })

  return <>{navItems}</>
}

export default MenuList
